const footerLinks = {
  快速导航: [
    { label: '首页', href: '#hero' },
    { label: '特色优势', href: '#features' },
    { label: '专题合集', href: '#index' },
    { label: '更新动态', href: '#updates' },
    { label: '关于我们', href: '#about' },
  ],
  热门专题: [
    { label: '国产剧推荐', href: '#cards' },
    { label: '热播剧排行', href: '#ranking' },
    { label: '最新上线', href: '#updates' },
    { label: '话题讨论', href: '#topics' },
    { label: '常见问答', href: '#faq' },
  ],
  服务支持: [
    { label: '投稿合作', href: '#contact' },
    { label: '观影指南', href: '#faq' },
    { label: '观众评论', href: '#comments' },
    { label: '媒体资源', href: '#media' },
  ],
};

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-950 font-bold text-lg">
                60
              </span>
              <span className="text-foreground-950 font-heading font-bold text-lg">
                6080新视觉影院
              </span>
            </div>
            <p className="text-foreground-500 text-sm leading-relaxed">
              6080新视觉影院致力于为用户提供电视剧全集免费在线观看服务，最新电视剧高清不卡顿，流畅不缓冲秒开播放，免费看全集，打造极致观影体验。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-foreground-800 font-semibold text-sm mb-4">{title}</h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-foreground-500 hover:text-primary-500 text-sm transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/60 pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} 6080新视觉影院. 本站内容仅供交流学习，请于下载后24小时内删除。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-foreground-500 text-xs">合作伙伴</span>
              <span className="text-foreground-400 text-xs">虚位以待</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}